// extracted by mini-css-extract-plugin
module.exports = {"cookieConsent":"styles-module--cookieConsent--2I9Tp"};